// libs
import { getExperimentVariant } from '@nykaa/experiment-sdk/client';

// constants
import { CHECKOUT_EXPT_VARIANTS } from 'shared/constants';
import { CHECKOUT_V2_ADDRESS_URI, NEW_PAYMENT_STACK } from 'shared/constants/uri';

// helpers
import { getDeviceType } from 'shared/helpers/app';

// defs
import { CartItem } from 'shared/types/cart';

export const getAllImageFromItems = (items: CartItem[]) => {
  return items.map((item) => item.imageUrl);
};

export const getQueryParamsForCheckout = () => {
  const isMobile = getDeviceType() === 'MSITE';

  // return old address url for dweb
  if (!isMobile) return '';

  // check if user is eligible for new payment, redirect to new payment url
  const { isEligible, variant } = getExperimentVariant('checkout-ssr-mweb');

  if (isEligible) {
    return `exp=${variant}`;
  }

  return 'exp=DEFAULT';
};

export const getNewCheckoutURI = () => {
  const isMobile = getDeviceType() === 'MSITE';

  // return old address url for dweb
  if (!isMobile) return CHECKOUT_V2_ADDRESS_URI;

  // check if user is eligible for new payment, redirect to new payment url
  const { isEligible, variant } = getExperimentVariant('checkout-ssr-mweb');

  if (
    isEligible &&
    (variant === CHECKOUT_EXPT_VARIANTS.FCR || variant === CHECKOUT_EXPT_VARIANTS.PCI)
  ) {
    return `${NEW_PAYMENT_STACK}?${getQueryParamsForCheckout()}`;
  }

  return `${CHECKOUT_V2_ADDRESS_URI}?${getQueryParamsForCheckout()}`;
};
